export const getAccentTextColor = (tripTypeColor) => {
  if (tripTypeColor === 'PITSTOP_BLUE' || tripTypeColor === 'FREQ_FILL_IN_RED' || tripTypeColor === 'STOCKUP_PURPLE') {
    return '#fff';
  }
  return '#000';
};
